import { AvatarProps } from "@portal/BaseComponents/Avatar/type";
import { ThemeConfig } from "antd";

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: "#531DAB",
    fontSize: 14,
    lineHeight: 1.2,
    colorText: "#262626",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  },

  components: {
    Layout: {
      colorBgHeader: "#ffffff",
      colorBgBody: "#E5E5E5",
    },
    Button: {
      colorText: "#391085",
    },
    Typography: {
      colorLink: "#531DAB",
      colorLinkHover: "#531DAB",
      colorText: "#262626",
    },
  },
};

export const responsiveAvatarSize: AvatarProps["size"] = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 64,
  xl: 80,
  xxl: 100,
};
